<template>
  <div>
    <Head :Index="isIndex"/>
    <Banner :banner1="bannerObj1"/>
    <div class="auto_1280 menu-box">
      <Menu/>
    </div>
    <keep-alive>
      <router-view :key="$route.path" v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view :key="$route.path" v-if="!$route.meta.keepAlive"/>
    <Bottom :Index="isIndex"/>
  </div>
</template>
<script>
import Head from '@/components/header'
import Banner from '@/components/banner'
import Bottom from '@/components/bottom'
import Menu from '@/components/menu'
export default {
  components: {
    Head,
    Banner,
    Bottom,
    Menu
  },
  data () {
    return {
      isIndex: false,
      columnId: this.$route.query.columnId,
      bannerObj1: {}
    }
  },
  mounted () {
    if (sessionStorage.getItem('banner') === null) {
      this.init()
    } else {
      try {
        const id = parseInt(this.$route.query.columnId) || parseInt(localStorage.getItem('columnId'))
        const banner = JSON.parse(sessionStorage.getItem('banner'))
        banner.forEach((item) => {
          if (item.articleTypeId === id) {
            this.bannerObj1 = item
          }
        })
      } catch (err) {
        console.log(err)
      }
    }
    // this.init()
  },
  methods: {
    init () {
      const id = parseInt(this.$route.query.columnId) || parseInt(localStorage.getItem('columnId'))
      this.$api.post('api/benefitAdvert/queryByParam', { isDelete: 0, state: 1 }, r => {
        r.data.forEach((item) => {
          if (item.articleTypeId === id) {
            this.bannerObj1 = item
          }
          if (!this.bannerObj1.id) {
            this.bannerObj1 = {
              img: require('@/assets/vlovemother-banner-pc.jpg'),
              img2: require('@/assets/vlovemother-banner-wap.jpg')
            }
          }
        })
        sessionStorage.setItem('banner', JSON.stringify(r.data))
      })
    }
  }
}
</script>
<style scoped>
.menu-box{z-index: 50; position: relative;}
</style>
